// extracted by mini-css-extract-plugin
export default {"container":"suggest-tag_container__Cky4q","text":"suggest-tag_text__fVS80","label":"suggest-tag_label__Up-fL","description":"suggest-tag_description__yMmSV"};